import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import mfPersonForm from './pages/mfPersonForm.page';
import domElementGetter from '../shared/utilities/domElementGetter';

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: mfPersonForm,
  domElementGetter: () => domElementGetter('renderContainerId'),
});

export const bootstrap = [
  (): Promise<void> => {
    return Promise.resolve().then(() => {
      window.scrollTo(0, 0);
    });
  },
];

export const mount = [reactLifecycles.mount];

export const unmount = [reactLifecycles.unmount];
